<template>
  <div class="about-container info-html-wrapper">
    <h1 class="title">
      {{ $t('details.about-us') }}
    </h1>
    <html-loader :url="contentUrl" />
  </div>
</template>

<script>
import DefaultContentPage from './ContentPage/DefaultContentPage';

export default {
  extends: DefaultContentPage,
  data() {
    return {
      pageHandle: 'about',
    };
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/About.vue